"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RecoveryCodeInput = exports.SMSCodeInput = exports.TOTPCodeInput = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _vanillaTextMask = _interopRequireDefault(require("vanilla-text-mask"));

var _Input = _interopRequireDefault(require("../../components/Input"));

var MaskInput = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  (0, _react.useEffect)(function () {
    var maskedInputCdontroller = (0, _vanillaTextMask["default"])({
      inputElement: ref.current,
      mask: props.mask,
      placeholderChar: "\u2000"
    });
    return function () {
      maskedInputCdontroller.destroy();
    };
  }, [props.mask]);
  return /*#__PURE__*/_react["default"].createElement(_Input["default"], (0, _extends2["default"])({}, props, {
    ref: ref
  }));
});
var _default = MaskInput;
exports["default"] = _default;
var TOTPCodeInput = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(MaskInput, (0, _extends2["default"])({
    mask: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/]
  }, props, {
    ref: ref
  }));
});
exports.TOTPCodeInput = TOTPCodeInput;
var SMSCodeInput = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(MaskInput, (0, _extends2["default"])({
    mask: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/]
  }, props, {
    ref: ref
  }));
});
exports.SMSCodeInput = SMSCodeInput;
var RecoveryCodeInput = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(MaskInput, (0, _extends2["default"])({
    mask: [/[a-z]/, /[a-z]/, /[a-z]/, /[a-z]/, /[a-z]/, /[a-z]/, /[a-z]/, /[a-z]/]
  }, props, {
    ref: ref
  }));
});
exports.RecoveryCodeInput = RecoveryCodeInput;
//# sourceMappingURL=MaskInput.js.map